import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBeTkNw-1L5rQ1QRbuC9OnaKmjo-Jem5gs",
  authDomain: "ipncity-beta.firebaseapp.com",
  databaseURL: "https://ipncity-beta.firebaseio.com",
  projectId: "ipncity-beta",
  storageBucket: "ipncity-beta.appspot.com",
  messagingSenderId: "1044760530541",
  appId: "1:1044760530541:web:b221405144f02d0ce37964",
  measurementId: "G-C6NESZKK5C"
};

var fire = firebase.initializeApp(firebaseConfig);
export default fire;


export const serverTimeStamp = firebase.firestore.FieldValue.serverTimestamp()